// if (!customElements.get('quick-add-modal')) {
//   customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
//     constructor() {
//       super();
//       this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
//     }

//     hide(preventFocus = false) {
//       const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//       this.modalContent.innerHTML = '';

//       if (preventFocus) this.openedBy = null;
//       super.hide();
//     }

//     show(opener) {
//       opener.setAttribute('aria-disabled', true);
//       opener.classList.add('loading');
//       opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       fetch(opener.getAttribute('data-product-url'))
//         .then((response) => response.text())
//         .then((responseText) => {
//           const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//           console.log('ResponseHtml==>', responseHTML);
//           this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
//           this.preventDuplicatedIDs();
//           this.removeDOMElements();
//           this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

//           if (window.Shopify && Shopify.PaymentButton) {
//             Shopify.PaymentButton.init();
//           }

//           if (window.ProductModel) window.ProductModel.loadShopifyXR();

//           this.removeGalleryListSemantic();
//           this.updateImageSizes();
//           this.preventVariantURLSwitching();
//           super.show(opener);
//         })
//         .finally(() => {
//           opener.removeAttribute('aria-disabled');
//           opener.classList.remove('loading');
//           opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//     setInnerHTML(element, html) {
//       element.innerHTML = html;

//       // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//       element.querySelectorAll('script').forEach(oldScriptTag => {
//         const newScriptTag = document.createElement('script');
//         Array.from(oldScriptTag.attributes).forEach(attribute => {
//           newScriptTag.setAttribute(attribute.name, attribute.value)
//         });
//         newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//         oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//       });
//     }

//     preventVariantURLSwitching() {
//       const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
//       if (!variantPicker) return;

//       variantPicker.setAttribute('data-update-url', 'false');
//     }

//     removeDOMElements() {
//       const pickupAvailability = this.productElement.querySelector('pickup-availability');
//       if (pickupAvailability) pickupAvailability.remove();

//       const productModal = this.productElement.querySelector('product-modal');
//       if (productModal) productModal.remove();

//       const modalDialog = this.productElement.querySelectorAll('modal-dialog');
//       if (modalDialog) modalDialog.forEach(modal => modal.remove());
//     }

//     preventDuplicatedIDs() {
//       const sectionId = this.productElement.dataset.section;
//       this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
//       this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
//         element.dataset.originalSection = sectionId;
//       });
//     }

//     removeGalleryListSemantic() {
//       const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
//       if (!galleryList) return;

//       galleryList.setAttribute('role', 'presentation');
//       galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
//     }

//     updateImageSizes() {
//       const product = this.modalContent.querySelector('.product');
//       const desktopColumns = product.classList.contains('product--columns');
//       if (!desktopColumns) return;

//       const mediaImages = product.querySelectorAll('.product__media img');
//       if (!mediaImages.length) return;

//       let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
//       if (product.classList.contains('product--medium')) {
//         mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//       } else if (product.classList.contains('product--small')) {
//         mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//       }

//       mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
//     }
//   });
// }

$(document).on('click', 'button.quick-add__submit', function(){
  const $this = $(this);
  const getUrl = $(this).attr('data-product-url'); console.log("Get Url",getUrl); 

  $this.attr('aria-disabled', true);
  $this.addClass('loading');
  $this.find('.loading-overlay__spinner').removeClass('hidden');
    
          fetch(getUrl)
            .then((response) => response.text())
            .then((responseText) => {
              console.log("Response Test-->", responseText);
              const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
              console.log('ResponseHtml==>', responseHTML);
              const getRenderData = responseHTML.querySelector('section[id^="MainProduct-"]');
              $(document).find('#QuickAdd-modal-layout #QuickAddInfo-quickview').html(getRenderData);

              // if($('body').attr('data-template') == 'collection'){
                console.log('inside product tmeplate')
                if($(document).find('#QuickAddInfo-quickview .product-form__input').attr('data-option') == 'color'){
                  var optionName = $(document).find('#QuickAddInfo-quickview .product-form__input[data-option="color"] input:checked').val();  console.log('colorname on ready==>', optionName);
                  var jsonContent =  $(document).find('#QuickAddInfo-quickview .product-form__input[data-option="color"]').closest('variant-radios').find('[type="application/json"]').text();  
                } else if($(document).find('#QuickAddInfo-quickview .product-form__input').attr('data-option') == 'size'){
                  var optionName = $(document).find('#QuickAddInfo-quickview .product-form__input[data-option="size"] input:checked').val();  console.log('Size on ready==>', optionName);
                  var jsonContent =  $(document).find('#QuickAddInfo-quickview .product-form__input[data-option="size"]').closest('variant-radios').find('[type="application/json"]').text();
  
                }
                var jsonData =  $.parseJSON(jsonContent);
                console.log("Quick view json data==>", jsonData);
                updateLensDescption(jsonData, optionName);
              // }
              $(document).find('#QuickAdd-modal-layout').attr('open','open')
              
              // this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
              // this.preventDuplicatedIDs();
              // this.removeDOMElements();
              // this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
    
              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
    
              if (window.ProductModel) window.ProductModel.loadShopifyXR();
    
              // this.removeGalleryListSemantic();
              // this.updateImageSizes();
              // this.preventVariantURLSwitching();
              // super.show(opener);
            })
            .finally(() => {
              $this.removeAttr('aria-disabled');
              $this.removeClass('loading');
              $this.find('.loading-overlay__spinner').addClass('hidden');
            });
        

});

$(document).on('click', '#ModalClose-quickview, #QuickAdd-modal-layout-overlay', function(event){
  $(document).find('#QuickAdd-modal-layout').removeAttr('open')
  // const box = $(document).find('.quick-add-modal__content');

  //       if(event.target != box && event.target.parentNode != box){
  //         box.closest('#QuickAdd-modal-layout').removeAttr('open')
  //       }
})
